module.exports = __webpack_public_path__ + "img/m-nex22-menu-desktop.fc299309.png";